import { Level } from '../types/level';
import { boolHttp, http } from './http';
import { DeleteDictUrl, GetHeapUrl, LangsUrl } from './urls';

interface GetLangsResponse {
  id: number;
  code: string;
}

interface DeleteDictRequest {
  lang: string;
  word: string;
}

interface GetHeapRequest {
  lang: string;
  keyword: string;
  min: number;
  max: number;
}

export interface GetHeapResponse {
  main: string;
  variants: string[];
  stats: WordStats[];
}

export interface GetFullLevelResponse {
  levels: Level[];
  heap: {
    main: string;
    variants: string[];
    stats: WordStats[];
  };
}

export type RebuildResponse = Level[];

export interface WordStats {
  word: string;
  usage: number;
  desc?: string | null;
}

const WordService = {
  getLangs: async (): Promise<GetLangsResponse[]> => {
    const req = new Request(LangsUrl(), { method: 'GET' });
    return await http<GetLangsResponse[]>(req);
  },

  deleteDict: async (lang: string, word: string): Promise<boolean> => {
    const req = new Request(DeleteDictUrl(), {
      method: 'DELETE',
      body: JSON.stringify({ lang: lang, word: word } as DeleteDictRequest),
    });

    return await boolHttp(req);
  },

  getHeap: async (lang: string, keyword: string = ''): Promise<GetHeapResponse> => {
    const req = new Request(GetHeapUrl(), {
      method: 'POST',
      body: JSON.stringify({ lang: lang, keyword: keyword } as GetHeapRequest),
    });

    return await http<GetHeapResponse>(req);
  },
};

export default WordService;
